import React from 'react';
import { Box, Typography, Grid, Link, Card, CardContent, CardActions, Button } from '@mui/material';
import Footer from './footer';


const projectsData = [
  {
    title: 'React dashboard',
    description: 'Displays data for analysis and visualization, with consumed REST APIs utilized to retrieve data from the database. Styling and theming are implemented using Material-UI.',
    repoLink: 'https://github.com/evahaudi/final.git',
    imageSrc: "/images/react.jpg"
  },
  {
    title: 'Portfolio Web',
    description: 'An app web that showcase my skill,and it is developed using react js ,material ui theming and styling.',
    repoLink: 'https://github.com/evahaudi/myportfolio.git',
    imageSrc: "/images/portfolio.jpg"
  },
  {
    title: 'Barbershop checkout web',
    description: 'A system that is used manage operations in barbershops',
    repoLink: 'https://github.com/evahaudi/lighting.git',
    imageSrc: 'https://quickshavecheckout.evah-audi.tech/', 
  },
  {
    title: 'Apex oracle dashboard app',
    description: 'Displays data for analysis and visualization and its integrated with oracle graph server.',
    repoLink: 'https://github.com/evahaudi/myportfolio.git',
    imageSrc: "/images/apex.jpg"
  },
  {
    title: 'Oracle apex dashboard app',
    description: 'Displays data for analysis and visualization.',
    repoLink: 'https://github.com/evahaudi/myportfolio.git',
    imageSrc: '/images/false.jpg', 
  },
  {
    title: 'Apex dashboard app',
    description: 'Displays data for analysis and visualization.',
    repoLink: 'https://github.com/evahaudi/myportfolio.git',
    imageSrc: '/images/directors.jpg', 
  },
  
  
];

function ProjectsSection() {
  return (
    <Box my={4}>
      <Typography variant="h6"><b>The the below are some of my projects feel free to explore.</b></Typography>
      <br/>
      <Grid container spacing={3}>
        {projectsData.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardContent>
               <img src={project.imageSrc} alt={project.title} style={{ width: '100%', height: 'auto' }} />
                <Typography variant="h5">{project.title}</Typography>
                <Typography variant="body2">{project.description}</Typography>
              </CardContent>
              <CardActions>
                <Link href={project.repoLink} target="_blank" rel="noopener">
                  <Button size="small" color="primary">
                    View GitHub Repo
                  </Button>
                </Link>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
      <br/>
      <br/>
      <Footer />
    </Box>
  );
}

export default ProjectsSection;
